import loadable from '@loadable/component';

export const LazyBookYourStay = loadable(() => import(/* webpackChunkName: "content/hotel/bookyourstay" */ './BookYourStay'));
